package com.patronat.top.features.usermanagement.data.repository

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.core.domain.models.profiles.UserFilter
import com.patronat.top.dto.UserStatus
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.features.usermanagement.data.mappers.toDomain
import com.patronat.top.features.usermanagement.data.network.UserRemoteDataStore
import com.patronat.top.features.usermanagement.domain.models.FilteredUsers

class ProfileRepositoryImpl(
    private val userRemoteDataStore: UserRemoteDataStore,
) : ProfileRepository {

    override suspend fun getCurrentUser(): DomainResult<User> {
        return userRemoteDataStore.getCurrentUser().asDomainResult { it.toDomain() }
    }

    override suspend fun createUser(user: User): DomainResult<User> {
        return userRemoteDataStore.createUser(user).asDomainResult { it.toDomain() }
    }

    override suspend fun getFilteredUsers(userFilter: UserFilter): DomainResult<FilteredUsers> {
        return userRemoteDataStore.getFilteredUsers(userFilter).asDomainResult { it.toDomain() }
    }

    override suspend fun updateUserStatus(userId: String, newStatus: UserStatus): DomainResult<Unit> {
        return userRemoteDataStore.updateUserStatus(userId, newStatus).asDomainResult { }
    }

    override suspend fun getUserById(userId: String): DomainResult<User> {
        return userRemoteDataStore.getUserById(userId).asDomainResult { it.toDomain() }
    }

    override suspend fun updateUser(user: User): DomainResult<Unit> {
        return userRemoteDataStore.updateUser(user).asDomainResult { }
    }
}